(() => {
  'use strict';

  const closeDesktopMenus = (header, except) => {
    header.querySelectorAll('.ott-h340__desktop-nav details[open]').forEach((details) => {
      if (details !== except) details.removeAttribute('open');
    });
  };

  const setMobileState = (menu, open) => {
    const summary = menu.querySelector(':scope > summary');
    if (summary) summary.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.classList.toggle('ott-v508-menu-open', open);
  };

  const closeMobileMenu = (header) => {
    const menu = header.querySelector('.ott-h340__mobile-menu');
    if (!menu) return;
    menu.removeAttribute('open');
    setMobileState(menu, false);
  };

  const initialise = (header) => {
    if (!header || header.dataset.ottV511HeaderReady === 'true') return;
    header.dataset.ottV511HeaderReady = 'true';
    header.setAttribute('data-ott-header-runtime', 'v511-stable');

    header.querySelectorAll('[data-ott-account-shell]').forEach((shell) => {
      shell.dataset.ottAccountState = 'guest';
    });
    header.querySelectorAll('[data-ott-account-link]').forEach((link) => {
      link.dataset.ottAccountState = 'guest';
    });

    header.querySelectorAll('.ott-h340__desktop-nav details').forEach((details) => {
      details.addEventListener('toggle', () => {
        if (details.open) closeDesktopMenus(header, details);
      });
    });

    const mobileMenu = header.querySelector('.ott-h340__mobile-menu');
    if (mobileMenu) {
      mobileMenu.addEventListener('toggle', () => setMobileState(mobileMenu, mobileMenu.open));
      mobileMenu.querySelectorAll('a[href]').forEach((link) => {
        link.addEventListener('click', () => closeMobileMenu(header));
      });
    }

    document.addEventListener('click', (event) => {
      if (!header.contains(event.target)) closeDesktopMenus(header);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      closeDesktopMenus(header);
      closeMobileMenu(header);
    });
  };

  const boot = (scope = document) => scope.querySelectorAll('.ott-h340').forEach(initialise);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(), { once: true });
  else boot();
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
  window.addEventListener('resize', () => {
    if (window.innerWidth >= 990) document.querySelectorAll('.ott-h340').forEach(closeMobileMenu);
  }, { passive: true });
})();
